/* eslint-disable */
export default {
  title: '오디오',
  dialButtonVolume: '다이얼 버튼 볼륨',
  ringtoneVolume: '벨소리 볼륨',
  callVolume: '통화량',
  muteCalls: '통화 음소거',
  outputDevice: '출력 디바이스',
  inputDevice: '입력 디바이스',
  micPermission: '마이크 권한',
  noDevice: '디바이스 없음',
  checkMicPermission: '권한 확인',
  micNoPermissionMessage: '앱에 마이크를 사용할 수 있는 권한이 없습니다.',
  noLabel: '알 수 없는 디바이스',
  notSetSinkIdTip:
    '죄송합니다. 현재 브라우저 권한이 오디오 출력 디바이스에 액세스할 수 있도록 설정되지 않았습니다. 설정 방법을 보려면 {clickHereLink}하세요.',
  noLabelTip:
    '죄송합니다. 현재 브라우저 권한이 오디오 입력 디바이스에 액세스할 수 있도록 설정되지 않았습니다.',
  clickHere: '여기를 클릭',
  defaultOutputDevice: '기본 출력 디바이스',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"dialButtonVolume"@#@ @source: @#@"Dial Button Volume"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone Volume"@#@
// @key: @#@"callVolume"@#@ @source: @#@"Call Volume"@#@
// @key: @#@"muteCalls"@#@ @source: @#@"Mute Calls"@#@
// @key: @#@"outputDevice"@#@ @source: @#@"Output Device"@#@
// @key: @#@"inputDevice"@#@ @source: @#@"Input Device"@#@
// @key: @#@"micPermission"@#@ @source: @#@"Microphone Permission"@#@
// @key: @#@"noDevice"@#@ @source: @#@"No device"@#@
// @key: @#@"checkMicPermission"@#@ @source: @#@"Check Permission"@#@
// @key: @#@"micNoPermissionMessage"@#@ @source: @#@"The app does not have permission to use microphone"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"notSetSinkIdTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio output devices. {clickHereLink} to see how to set up."@#@
// @key: @#@"noLabelTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio input devices."@#@
// @key: @#@"clickHere"@#@ @source: @#@"Click here"@#@
// @key: @#@"defaultOutputDevice"@#@ @source: @#@"Default output device"@#@
